import type { ContentStatus, LawyerProfile } from "@/api/profiles/types";

function sortEditionsComEnFirst(
  a: LawyerProfile["languageVersions"] extends (infer V)[] | undefined ? V : never,
  b: LawyerProfile["languageVersions"] extends (infer V)[] | undefined ? V : never,
): number {
  if (a.website === "com_en" && b.website !== "com_en") return -1;
  if (b.website === "com_en" && a.website !== "com_en") return 1;
  return 0;
}

/**
 * Expands each representative `LawyerProfile` (one per lawyer, as returned by
 * the list endpoint) into one row per language/site edition, overlaying each
 * edition's own id/language/website/status onto the representative's shared
 * identity fields. `com_en` sorts first; an optional `statusFilter` keeps
 * only editions whose own status matches.
 */
export function toEditionRows(
  profiles: LawyerProfile[],
  statusFilter?: ContentStatus,
): LawyerProfile[] {
  return profiles.flatMap(representative => {
    const editions = representative.languageVersions;
    if (!editions || editions.length === 0) {
      return [representative];
    }

    return [...editions]
      .sort(sortEditionsComEnFirst)
      .filter(edition => !statusFilter || edition.status === statusFilter)
      .map(edition => ({
        ...representative,
        id: edition.id,
        languageCode: edition.languageCode,
        website: edition.website,
        status: edition.status,
      }));
  });
}
